var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align-items progressbar-wrapper"},[_c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"bar",style:('width: ' + _vm.percentage + '%')},[_c('div',{staticClass:"indicator"},[_vm._v(_vm._s(_vm.progress))])])]),_c('div',{staticClass:"total"},[_vm._v("/ "+_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }